import Header from "../components/landingComponents/Header";
import Footer from "../components/landingComponents/Footer";
import "./StripePage.css";
import Stripe from "../components/Stripe";
import StripeCoin from "../components/StripeCoin";

const LandingPage = () => {
  return (
    <div className="stripePage">
      <Header disappearNavlink={true} />
      <Stripe />
      <Footer disappearPlatform={true} />
      <StripeCoin />
    </div>
  );
};

export default LandingPage;
